import {useEffect, useState} from "react"
import {Card, Col, Row} from "react-bootstrap";
import {UsePost} from "../../hooks/http";
import {UseMessage} from "../../hooks/UseMessage";
import SegmentForm from "./SegmentForm";
import {useNavigate} from "react-router-dom";
import {GetFields} from "./GetFields";

const SegmentCreate = ({audience, id2}) => {

    const navigate = useNavigate()
    const [errors, setErrors] = useState()
    const [isLoading, setIsLoading] = useState(true)
    const [queryFields, setQueryFields] = useState([])



    const handleUpdate = (PostData) => {
        setIsLoading(true)
        UsePost(
            `/audiences/${audience?._id?.$oid}/segments/upsert`,
            {data: PostData}
        ).then((response) => {
            window.setTimeout(() => {
                if (response.code >= 200 && response.code <= 299) {
                    navigate(`/audiences/${audience?._id?.$oid}/segments/${response.id}`)
                    UseMessage('success', 'Segment has been successfully updated')
                    setErrors(undefined)
                } else {
                    setErrors(response.errors)
                }
                setIsLoading(false)
            }, 1500)
        })
    }



    useEffect(() => {
        const response = GetFields({audience});
        setQueryFields(response?.fields);
        setIsLoading(false)
    }, [])



    return (
        <>
            <Card>
                <Row>
                    <Col>
                        <div className="max-width-720">
                            <SegmentForm
                                errors={errors}
                                audience={audience}
                                fields={queryFields}
                                isReady={!isLoading}
                                onSubmit={handleUpdate}
                            />
                        </div>
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export default SegmentCreate